// extracted by mini-css-extract-plugin
module.exports = {"answerInputContainer":"styles_answerInputContainer__2NghG","answerInput":"styles_answerInput__3MnZ4 typography_defaultText__3yE-Q"};